// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] + "-" + {"230":"b1b8db1cdc083b9685d8","256":"b153cf13dbd97e1387b6","532":"92bb726d50758af1de03"}[chunkId] + ".js";
};